import React from 'react';
import AssociationReports from '../components/business/AssociationReports';

export const AssociationReportsCtx = React.createContext({});

function AssociationReportsPageProvider(props) {
  const ctx = {

  };

  return (
    <AssociationReportsCtx.Provider value={ ctx }>
      {props.children}
    </AssociationReportsCtx.Provider>
  );
}

function AssociationReportsPage() {
  return (
    <AssociationReportsPageProvider>
      <AssociationReports />
    </AssociationReportsPageProvider>
  );
}
export default AssociationReportsPage;
